/*
═══════════════════════════════════════════════════════════
НАСТРОЙКА НА ЯСНОСТЬ / CLARITY
═══════════════════════════════════════════════════════════
Автор: @Elena_evolvecode
Telegram: @na_sh_kodila
Создано: 2025-2026
Все права защищены
═══════════════════════════════════════════════════════════
*/

import React from 'react';
import { motion } from 'framer-motion';

const EveningPrep = ({ onComplete, isWaiting }) => {
  return (
    <div style={styles.container}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={styles.content}
      >
        <div style={styles.icon}>☽</div>

        <h1 style={styles.title}>ПОДГОТОВКА</h1>

        <p style={styles.subtitle}>
          Твоя практика начнётся завтра утром.
          <br />
          Но настройка идёт уже сейчас.
        </p>

        <div style={styles.taskCard}>
          <h3 style={styles.taskTitle}>Задание на вечер</h3>
          <p style={styles.taskText}>
            Присядь, где находишься.
          </p>
          <p style={styles.taskText}>
            Найди вниманием один звук (например, гул прибора) и второй звук (например, шум за окном).
          </p>
          <p style={styles.taskText}>
            Попробуй слушать их одновременно.
          </p>
          <p style={styles.taskText}>
            Сначала внимание будет прыгать между ними - не борись с этим.
          </p>
          <p style={styles.taskText}>
            В какой-то момент оно расширится, и ты услышишь весь объём пространства сразу.
          </p>
          <p style={styles.taskHighlight}>
            Это мгновение чистой ясности.
          </p>
          <p style={styles.taskText}>
            Зафиксируй его и иди заниматься своими делами.
          </p>
        </div>

        <p style={styles.closing}>Увидимся утром.</p>

        {isWaiting ? (
          <div style={styles.waitingBadge}>
            <span style={styles.waitingDot}></span>
            <span style={styles.waitingLabel}>Ожидание нового дня...</span>
          </div>
        ) : (
          <button style={styles.button} onClick={onComplete}>
            ПОНЯТНО
          </button>
        )}
      </motion.div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)',
  },
  content: {
    maxWidth: '360px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '24px',
  },
  title: {
    color: '#E5D2A0',
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '4px',
    marginBottom: '16px',
  },
  subtitle: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '15px',
    lineHeight: '1.7',
    marginBottom: '32px',
  },
  taskCard: {
    background: 'rgba(229, 210, 160, 0.08)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(229, 210, 160, 0.2)',
    borderRadius: '16px',
    padding: '24px 20px',
    marginBottom: '24px',
    textAlign: 'left',
  },
  taskTitle: {
    color: '#E5D2A0',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginBottom: '16px',
    textAlign: 'center',
  },
  taskText: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '15px',
    lineHeight: '1.7',
    marginBottom: '12px',
  },
  taskHighlight: {
    color: '#E5D2A0',
    fontSize: '15px',
    fontWeight: '500',
    lineHeight: '1.7',
    marginBottom: '12px',
    fontStyle: 'italic',
  },
  closing: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '15px',
    marginBottom: '32px',
    fontStyle: 'italic',
  },
  button: {
    padding: '16px 48px',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#E5D2A0',
    borderRadius: '30px',
    color: '#E5D2A0',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '3px',
    cursor: 'pointer',
  },
  waitingBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '14px 24px',
    background: 'rgba(229, 210, 160, 0.1)',
    borderRadius: '30px',
  },
  waitingDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#E5D2A0',
    animation: 'pulse 2s ease-in-out infinite',
  },
  waitingLabel: {
    color: 'rgba(229, 210, 160, 0.8)',
    fontSize: '13px',
    letterSpacing: '1px',
  },
};

export default EveningPrep;
